<template>

  <div class="row">
    <div class="col-12">
      <div v-if="wpdata.announcement" class="announcement" v-html="wpdata.announcement"></div>
    </div>



    <div class="col-lg-6" id="live-stream">
      <card class="card-stats" :show-footer-line="true">
          <div class="row">
            <div class="col-5">
              <div class="info-icon text-center icon-primary">
                <slot name="icon"> <i class="tim-icons icon-sound-wave"></i> </slot>
              </div>
            </div>
            <div class="col-7">
              <div class="numbers">
                <slot>

                  <h3 class="card-title">Live Stream</h3>
                </slot>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div style="height: 22rem; margin: 1rem 0 0 0;">
             <iframe src="/members-education-center/live-stream/" width="100%" height="100%" frameborder="0" scrolling="no" allow="autoplay" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" oallowfullscreen="" msallowfullscreen=""></iframe>  </div>
              </div>
          </div>
        </card>


    </div>





    <div class="col-lg-6" id="live-chat">
      <card class="card-stats" :show-footer-line="true">
          <div class="row d-flex align-items-center">
            <div class="col-5">
              <div class="info-icon text-center icon-primary">
                <slot name="icon"> <i class="tim-icons icon-chat-33"></i> </slot>
              </div>
            </div>
            <div class="col-7">
              <div class="numbers">
                <slot>
                  <h3 class="card-title">Live Chat</h3>

                </slot>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div style="margin: 1rem 0 0 0; border: 1px solid #2b3553; margin: 1rem 0 1rem 0;">
                <ul id="chatScroll" v-on:scroll.passive='chatScroll' style="position: relative; height: 15rem; padding: 0rem 0.5rem; margin:0; overflow: scroll;" class="list-unstyled">
                  <li class="text-color"
                      v-bind:class="{ muted: isMuted(message), private: isPrivate(message), highlight: highlight(message), highlightadmin: highlightadmin(message) }"
                      v-if="! hidePrivate(message)"
                      v-for="message in chat"
                      :key="message.id"
                  >
                    <el-tooltip :content="unixMilisecondsToDate(message.time)"
                                effect="dark"
                                :open-delay="300"
                                placement="top">
                      <b role="button" style="color: white;" @click="showUserModal(message.name)" class="cursor">{{message.name}}:</b>
                    </el-tooltip> <span v-html="message.message"></span>
                  </li>
                </ul>
              </div>
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-11">
                  <input style="padding: 0.5rem 1rem;" v-on:keyup.enter="sendMessage()" v-model="message" id="input-message" class="form-control form-control-lg" type="text" placeholder=" Enter Message">



                </div>
                <div class="col-1 text-center">
                  <popper
                    trigger="clickToToggle"
                    :options="{
                      placement: 'top-end',
                      modifiers: { offset: { offset: '0,10px' } }
                    }"
                  >
                    <div class="popper" id="EmojiList">
                      <div style="width: 200px; height: 100px;"><span style="display: block; float: left;" v-for="(item, key) in emoji" :key="key"><img v-on:click="addEmojiToMessage(key)" :src="item" alt="" style="min-width: 20px; cursor: pointer;"></span></div>
                    </div>

                    <a slot="reference" style="color: #ad71e0; cursor: pointer;"><i style="font-size: 1.15rem;" class="mx-1 tim-icons icon-satisfied"></i></a>
                  </popper>
                  <a style="color: #ad71e0; cursor: pointer;" v-on:click="attachFile()"><i style="font-size: 1.25rem;" class="tim-icons icon-attach-87"></i></a>
                </div>
              </div>


            </div>

            <input @change="uploadFile" style="display: none;" ref="filebtn" id="fileUpload" class="form-control-file" type="file">

          </div>
          <div class="stats" slot="footer">
            <slot name="footer">{{chatCount}} Users Online <span style="color: #00f2c3" v-if="helpers.isPriavteMode">- Turn off private messages to user <span v-if="status" role="button" v-for="(status, user) in helpers.showPrivateUser" :key="user" @click="togglePrivateUser(user)" >@{{ user }} </span></span></slot>
            <div id="usersOnline" class="users-online">
              <span v-for="user in usersOnline" :key="user.id"
              >
                <img :src="user.avatar" alt="" v-on:click="togglePrivateUser(user.login)" />
              </span>
            </div>
          </div>
        </card>
      </div>

          <div class="col-md-12">
            <card card-body-classes="table-full-width">
              <div style="padding: 0.5rem 0;">
              <div class="form-row">

                <div class="col-6 col-lg-6">
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" @click="modals.filters = true" class="btn btn-md btn-simple btn-primary">Filters</button>
                    <button type="button" @click="modals.settings = true" class="btn btn-md btn-simple btn-primary">Settings</button>
                  </div>
                </div>

                <div class="d-none d-md-block col-md-6 text-right">

                 <i v-show="areAlertsLoading" style="padding: 16px;" class="tim-icons icon-refresh-02"></i>
               </div>
              </div>
            </div>

              <modal :show.sync="modals.user" type="mini" class="modal-primary" modal-content-classes="box-shadow">
                <div class="modal-content" v-if="selectedUser.status !== undefined && selectedUser.status === 'success'">
                  <div class="modal-header justify-content-center">
                    <div class="modal-profile">
                      <img :src="selectedUser.userAvatar" alt="">
                    </div>
                  </div>
                  <div class="modal-body">
                    <p>{{selectedUser.userName}}</p>
                  </div>
                  <div class="modal-footer justify-content-center">
                    <label>Private Messages: </label>
                    <base-switch class="base nudge ml-0" v-model="helpers.isPriavteMode" v-on:input="togglePrivateUser(selectedUser.login)" on-text="On" off-text="Off"></base-switch>
                  </div>
                </div>
                <div class="modal-content" v-else>
                  <div class="modal-header justify-content-center">
                    <div class="modal-profile">
                      <i class="tim-icons icon-single-02"></i>
                    </div>
                  </div>
                  <div class="modal-body">
                    <p>{{selectedUser.message}}</p>
                  </div>
                </div>
              </modal>

              <modal :show.sync="modals.filters" body-classes="p-0" modal-classes="modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <base-button type="secondary" @click="modals.filters = false" class="close"><i class="tim-icons icon-simple-remove"></i></base-button>
                  </div>
                </div>

                 <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
                    <h3>Filters</h3>

                    <form>
                      <div class="row">

                        <div class="col-12 col-sm-6 col-lg-4">
                          <p style="margin-bottom: 1rem;">
                          <label>Forex</label><br>
                          <el-select multiple
                                     class="select-primary snudge"
                                     collapse-tags
                                     v-model="selectedForex"
                                     placeholder="Forex">
                            <el-option v-for="option in forex"
                                       class="select-primary"
                                       :value="option.value"
                                       :label="option.label"
                                       :key="option.label">
                            </el-option>
                          </el-select>
                        </p>
                      </div >

                        <div class="col-12 col-sm-6 col-lg-4">
                        <p style="margin-bottom: 1rem;">
                          <label>Futures</label><br>
                          <el-select multiple
                                     class="select-primary snudge"
                                     collapse-tags
                                     v-model="selectedFutures"
                                     placeholder="Futures">
                            <el-option v-for="option in futures"
                                       class="select-primary"
                                       :value="option.value"
                                       :label="option.label"
                                       :key="option.label">
                            </el-option>
                          </el-select>
                        </p>
                      </div >

                        <div class="col-12 col-sm-6 col-lg-4">
                        <p style="margin-bottom: 1rem;">
                          <label>Indexes</label><br>
                          <el-select multiple
                                     class="select-primary snudge"
                                     collapse-tags
                                     v-model="selectedIndexes"
                                     placeholder="Indexes">
                            <el-option v-for="option in indexes"
                                       class="select-primary"
                                       :value="option.value"
                                       :label="option.label"
                                       :key="option.label">
                            </el-option>
                          </el-select>
                        </p>
                      </div >

                      <div class="col-12 col-sm-6 col-lg-4">
                        <p style="margin-bottom: 1rem;">
                          <label>Crypto</label><br>
                          <el-select multiple
                                     class="select-primary snudge"
                                     collapse-tags
                                     v-model="selectedCrypto"
                                     placeholder="Crypto">
                            <el-option v-for="option in crypto"
                                       class="select-primary"
                                       :value="option.value"
                                       :label="option.label"
                                       :key="option.label">
                            </el-option>
                          </el-select>
                        </p>
                      </div >


                           <div class="col-12 col-sm-6 col-lg-4">
                        <p style="margin-bottom: 1rem;">
                          <label>Period</label><br>
                          <el-select multiple
                                     class="select-primary snudge"
                                     collapse-tags
                                     v-model="filters.period"
                                     placeholder="Column Presets">
                            <el-option v-for="option in periods"
                                       class="select-primary"
                                       :value="option.value"
                                       :label="option.label"
                                       :key="option.label">
                            </el-option>
                          </el-select>
                        </p>
                      </div>
                         <div class="col-12 col-sm-6 col-lg-4">

                        <p style="margin-bottom: 1rem;">
                          <label>Pattern</label>
                          <el-select multiple
                                     class="select-primary snudge"
                                     collapse-tags
                                     v-model="filters.pattern"
                                     placeholder="Column Presets">
                            <el-option v-for="option in patterns"
                                       class="select-primary"
                                       :value="option.value"
                                       :label="option.label"
                                       :key="option.label">
                            </el-option>
                          </el-select>
                        </p>
                        </div>

                      <div class="col-12">

                        <base-input v-model="filters.id" addon-left-icon="tim-icons icon-settings-gear-63"  type="text" label="ID" placeholder="Enter ID"/>
                        <base-input v-model="filters.min_rvr"addon-left-icon="tim-icons icon-settings-gear-63" type="text" label="Min RVR" placeholder="Enter RVR"/>
                        <base-input v-model="filters.max_rvr" addon-left-icon="tim-icons icon-settings-gear-63" type="text" label="Max RVR" placeholder="Enter RVR"/>
                        <div class="form-row">
                          <base-input class="col-4" label="Operand">
                            <select v-model="filters.structure_op" class="form-control" id="exampleFormControlSelect1">
                              <option class="optionfix">=</option>
                              <option class="optionfix">></option>
                              <option class="optionfix"><</option>
                              <option class="optionfix">>=</option>
                              <option class="optionfix"><=</option>
                            </select>
                          </base-input>
                          <base-input v-model="filters.structure" class="col-8" addon-left-icon="tim-icons icon-settings-gear-63" type="text" label="Structure" placeholder="Enter Rating"/>
                        </div>
                      </div>



                    </div>


                   </form>


                 </card>
              </modal>

              <modal :show.sync="modals.settings" body-classes="p-0" modal-classes=" modal-sm">
                <div class="modal-content">
                  <div class="modal-header">
                    <base-button type="secondary" @click="modals.settings = false" class="close"><i class="tim-icons icon-simple-remove"></i></base-button>
                  </div>
                </div>
                 <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
                    <h3>Settings</h3>
                    <label>Columns</label><br>

                      <el-select
                                multiple
                                 class="select-primary snudge"
                                 collapse-tags
                                 v-model="settings.columnPresets"
                                 placeholder="Column Presets">
                        <el-option v-for="option in presetValues"
                                   class="select-primary"
                                   :value="option.value"
                                   :label="option.label"
                                   :key="option.label">
                        </el-option>
                      </el-select>
                    <form>
                      <div class="form-row">
                       <div class="col-md-12">


                         <p>

                             <base-input label="Timezone">
                               <select v-model="settings.timezone" class="form-control" id="exampleFormControlSelect1">
                                 <option class="optionfix" value="UTC-12:00">UTC−12:00</option>
                                 <option class="optionfix" value="UTC-11:00">UTC−11:00</option>
                                 <option class="optionfix" value="UTC-10:00">UTC−10:00</option>
                                 <option class="optionfix" value="UTC-09:30">UTC−09:30</option>
                                 <option class="optionfix" value="UTC-09:00">UTC−09:00</option>
                                 <option class="optionfix" value="UTC-08:00">UTC−08:00</option>
                                 <option class="optionfix" value="UTC-07:00">UTC−07:00</option>
                                 <option class="optionfix" value="UTC-06:00">UTC−06:00</option>
                                 <option class="optionfix" value="UTC-05:00">UTC−05:00</option>
                                 <option class="optionfix" value="UTC-04:00">UTC−04:00</option>
                                 <option class="optionfix" value="UTC-03:30">UTC−03:30</option>
                                 <option class="optionfix" value="UTC-03:00">UTC−03:00</option>
                                 <option class="optionfix" value="UTC-02:00">UTC−02:00</option>
                                 <option class="optionfix" value="UTC-01:00">UTC−01:00</option>
                                 <option class="optionfix" value="UTC+00:00">UTC+00:00</option>
                                 <option class="optionfix" value="UTC+01:00">UTC+01:00</option>
                                 <option class="optionfix" value="UTC+02:00">UTC+02:00</option>
                                 <option class="optionfix" value="UTC+03:00">UTC+03:00</option>
                                 <option class="optionfix" value="UTC+03:30">UTC+03:30</option>
                                 <option class="optionfix" value="UTC+04:00">UTC+04:00</option>
                                 <option class="optionfix" value="UTC+04:30">UTC+04:30</option>
                                 <option class="optionfix" value="UTC+05:00">UTC+05:00</option>
                                 <option class="optionfix" value="UTC+05:30">UTC+05:30</option>
                                 <option class="optionfix" value="UTC+05:45">UTC+05:45</option>
                                 <option class="optionfix" value="UTC+06:00">UTC+06:00</option>
                                 <option class="optionfix" value="UTC+06:30">UTC+06:30</option>
                                 <option class="optionfix" value="UTC+07:00">UTC+07:00</option>
                                 <option class="optionfix" value="UTC+08:00">UTC+08:00</option>
                                 <option class="optionfix" value="UTC+08:45">UTC+08:45</option>
                                 <option class="optionfix" value="UTC+09:00">UTC+09:00</option>
                                 <option class="optionfix" value="UTC+09:30">UTC+09:30</option>
                                 <option class="optionfix" value="UTC+10:00">UTC+10:00</option>
                                 <option class="optionfix" value="UTC+10:30">UTC+10:30</option>
                                 <option class="optionfix" value="UTC+11:00">UTC+11:00</option>
                                 <option class="optionfix" value="UTC+12:00">UTC+12:00</option>
                                 <option class="optionfix" value="UTC+12:45">UTC+12:45</option>
                                 <option class="optionfix" value="UTC+13:00">UTC+13:00</option>
                                 <option class="optionfix" value="UTC+14:00">UTC+14:00</option>
                               </select>
                             </base-input>
                           </p>
                         <p>
                        <label>Visual Alerts</label>
                        <base-switch class="base nudge" v-model="settings.visualAlerts" on-text="On" off-text="Off"></base-switch>
                      </p>

                      </div>
                      <div class="col-md-12">
                        <p>
                        <label>Audio Alerts</label>
                        <base-switch class="base nudge" v-model="settings.audioAlerts" on-text="On" off-text="Off"></base-switch>
                      </p>
                      <p>
                        <base-input label="Chat Alert">
                        <select v-model="settings.selectedChatSound" class="form-control">
                          <option class="optionfix" value="AirHorn.mp3">Air Horn</option>
                          <option class="optionfix" value="Bell-Alert.mp3">Bell Alert</option>
                          <option class="optionfix" value="China-Bright-Win.mp3">China Bright Win</option>
                          <option class="optionfix" value="DoorBell.mp3">Door Bell</option>
                          <option class="optionfix" value="Egyptian-Alert.mp3">Egyptian Alert</option>
                          <option class="optionfix" value="Magicians-Poof.mp3">Magicians Poof</option>
                          <option class="optionfix" value="Medieval-Alert.mp3">Medieval Alert</option>
                          <option class="optionfix" value="Notification-Bell-Alert.mp3">Bell Alert 2</option>
                          <option class="optionfix" value="Sharp-Quick-Whiz.mp3">Sharp Quick Whiz</option>
                          <option class="optionfix" value="Tropical-Alert.mp3">Tropical Alert</option>
                          <option class="optionfix" value="Videdogame-Attention-Alert.mp3">Videdogame Attention Alert</option>
                          <option class="optionfix" value="Video-Game-Power-Up.mp3">Video Game Power Up</option>
                          <option class="optionfix" value="bat_man.mp3">Bat Man</option>
                          <option class="optionfix" value="chat.mp3">Chat</option>
                          <option class="optionfix" value="duke_nukem.mp3">Duke Nukem</option>
                          <option class="optionfix" value="newalert-woman.mp3">New Alert Woman</option>
                          <option class="optionfix" value="notify-uk-man.mp3">Notify UK Man</option>
                          <option class="optionfix" value="notify.mp3">Notify</option>
                          <option class="optionfix" value="notify2.mp3">Notify 2</option>
                          <option class="optionfix" value="sonar_ping.mp3t.mp3">Sonar Ping</option>
                        </select>
                          <base-button block v-on:click="playSound(settings.selectedChatSound)">Play</base-button>
                        </base-input>
                      </p>
                      <p>
                        <base-input label="Private Chat Alert">
                        <select v-model="settings.selectedPrivateSound" class="form-control">
                          <option class="optionfix" value="AirHorn.mp3">Air Horn</option>
                          <option class="optionfix" value="Bell-Alert.mp3">Bell Alert</option>
                          <option class="optionfix" value="China-Bright-Win.mp3">China Bright Win</option>
                          <option class="optionfix" value="DoorBell.mp3">Door Bell</option>
                          <option class="optionfix" value="Egyptian-Alert.mp3">Egyptian Alert</option>
                          <option class="optionfix" value="Magicians-Poof.mp3">Magicians Poof</option>
                          <option class="optionfix" value="Medieval-Alert.mp3">Medieval Alert</option>
                          <option class="optionfix" value="Notification-Bell-Alert.mp3">Bell Alert 2</option>
                          <option class="optionfix" value="Sharp-Quick-Whiz.mp3">Sharp Quick Whiz</option>
                          <option class="optionfix" value="Tropical-Alert.mp3">Tropical Alert</option>
                          <option class="optionfix" value="Videdogame-Attention-Alert.mp3">Videdogame Attention Alert</option>
                          <option class="optionfix" value="Video-Game-Power-Up.mp3">Video Game Power Up</option>
                          <option class="optionfix" value="bat_man.mp3">Bat Man</option>
                          <option class="optionfix" value="chat.mp3">Chat</option>
                          <option class="optionfix" value="duke_nukem.mp3">Duke Nukem</option>
                          <option class="optionfix" value="newalert-woman.mp3">New Alert Woman</option>
                          <option class="optionfix" value="notify-uk-man.mp3">Notify UK Man</option>
                          <option class="optionfix" value="notify.mp3">Notify</option>
                          <option class="optionfix" value="notify2.mp3">Notify 2</option>
                          <option class="optionfix" value="sonar_ping.mp3t.mp3">Sonar Ping</option>
                        </select>
                          <base-button block v-on:click="playSound(settings.selectedPrivateSound)">Play</base-button>
                        </base-input>
                      </p>

                      <p>

                        <base-input label="Audio Alert">
                          <select v-model="settings.selectedSound" class="form-control" id="exampleFormControlSelect1">
                            <option class="optionfix" value="AirHorn.mp3">Air Horn</option>
                            <option class="optionfix" value="Bell-Alert.mp3">Bell Alert</option>
                            <option class="optionfix" value="China-Bright-Win.mp3">China Bright Win</option>
                            <option class="optionfix" value="DoorBell.mp3">Door Bell</option>
                            <option class="optionfix" value="Egyptian-Alert.mp3">Egyptian Alert</option>
                            <option class="optionfix" value="Magicians-Poof.mp3">Magicians Poof</option>
                            <option class="optionfix" value="Medieval-Alert.mp3">Medieval Alert</option>
                            <option class="optionfix" value="Notification-Bell-Alert.mp3">Bell Alert 2</option>
                            <option class="optionfix" value="Sharp-Quick-Whiz.mp3">Sharp Quick Whiz</option>
                            <option class="optionfix" value="Tropical-Alert.mp3">Tropical Alert</option>
                            <option class="optionfix" value="Videdogame-Attention-Alert.mp3">Videdogame Attention Alert</option>
                            <option class="optionfix" value="Video-Game-Power-Up.mp3">Video Game Power Up</option>
                            <option class="optionfix" value="bat_man.mp3">Bat Man</option>
                            <option class="optionfix" value="chat.mp3">Chat</option>
                            <option class="optionfix" value="duke_nukem.mp3">Duke Nukem</option>
                            <option class="optionfix" value="newalert-woman.mp3">New Alert Woman</option>
                            <option class="optionfix" value="notify-uk-man.mp3">Notify UK Man</option>
                            <option class="optionfix" value="notify.mp3">Notify</option>
                            <option class="optionfix" value="notify2.mp3">Notify 2</option>
                            <option class="optionfix" value="sonar_ping.mp3t.mp3">Sonar Ping</option>
                          </select>
                          <base-button block v-on:click="playSound(settings.selectedSound)">Play</base-button>
                        </base-input>
                      </p>
                    </div>
                    </div>
                   </form>
                 </card>
              </modal>

              <modal :show.sync="modals.image" body-classes="p-0" modal-classes="modal-xl modal-chart">
                 <img :src="viewImage" class="img-fluid">
              </modal>

              <div class="table-responsive">
              <table class="table alerts-table" role="table">
                <thead role="rowgroup">
                  <tr role="row">
                    <th style="min-width: 3rem;" v-show="showColumn('id')" role="columnheader">ID</th>
                    <th style="min-width: 9rem; text-align: center" v-show="showColumn('alert_direction')" scope="col" role="columnheader">Direction</th>
                    <th style="min-width: 9rem;" v-show="showColumn('alert_timestamp')" role="columnheader">Time</th>
                    <th style="min-width: 6rem;" v-show="showColumn('alert_symbol')" role="columnheader">Symbol</th>
                    <th style="min-width: 6rem; text-align: left" v-show="showColumn('alert_period')" role="columnheader">Period</th>
                    <th style="min-width: 3rem;" v-show="showColumn('alert_pattern')" role="columnheader">Pattern</th>
                    <th style="min-width: 9rem; text-align: right" v-show="showColumn('alert_currentprice')" role="columnheader">Current Price</th>
                    <th style="min-width: 12rem; text-align: right" v-show="showColumn('alert_enterbetween')" role="columnheader">Reversal Area</th>
                    <th style="min-width: 9rem; text-align: center" v-show="showColumn('alert_stopprice')" role="columnheader">Invalidation Point</th>
                    <th style="min-width: 6rem; text-align: center;" v-show="showColumn('alert_target1')" role="columnheader">Levels</th>
                    <th style="min-width: 6rem; text-align: center;" v-show="showColumn('alert_graph')" role="columnheader">Chart</th>
                    <th style="min-width: 6rem;" v-show="showColumn('alert_rvr')" role="columnheader">RvR</th>
                    <th style="min-width: 12rem;" v-show="showColumn('alert_score')" role="columnheader">Structure</th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <tr v-for="alert in filteredAlerts.slice(F,L)"  class="text-color" :key="alert.id">
                    <td v-show="showColumn('id')">{{alert.id}}</td>
                    <td v-show="showColumn('alert_direction')" align="center" v-html="directionIcon(alert.alert_direction)"></td>
                    <td v-show="showColumn('alert_timestamp')">{{unixToDate(alert.alert_timestamp)}}</td>
                    <td v-show="showColumn('alert_symbol')">{{alert.alert_symbol}}</td>
                    <td v-show="showColumn('alert_period')" align="left">{{alert.alert_period}}</td>
                    <td v-show="showColumn('alert_pattern')">{{alert.alert_pattern}}</td>
                    <td v-show="showColumn('alert_currentprice')" align="right">{{alert.alert_currentprice}}</td>
                    <td v-show="showColumn('alert_enterbetween')" align="right">{{alert.alert_enterbetween}}</td>
                    <td v-show="showColumn('alert_stopprice')" align="center">{{alert.alert_stopprice}}</td>
                    <td v-show="showColumn('alert_target1')" align="center">{{alert.alert_target1}}<br>{{alert.alert_target2}}<br>{{alert.alert_target3}}</td>
                    <td v-show="showColumn('alert_graph')" align="center"><a class="text-primary" style="cursor: pointer" @click="displayImageModal(alert.alert_graph)">View</a></td>
                    <td v-show="showColumn('alert_rvr')">{{alert.alert_rvr}}</td>
                    <td v-show="showColumn('alert_score')"><base-progress :value="alert.alert_score" :showValue="true" value-position="right" type="success" :height="45"></base-progress></td>

                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-wrapper d-block d-lg-flex align-items-center mt-2">
              <base-pagination :showArrows="false" :page-count="pageCount" v-model="page"></base-pagination>
              <div class="show-per-page ml-lg-4">
                <span class="text-color">Alerts per page: </span>
                <el-select class="select-primary snudge"
                           collapse-tags
                           v-model="perPage"
                           v-on:change="setAlertPagesCount"
                           placeholder="5">
                  <el-option class="select-primary" :value="5" :label="5" :key="5"></el-option>
                  <el-option class="select-primary" :value="10" :label="10" :key="10"></el-option>
                  <el-option class="select-primary" :value="20" :label="20" :key="20"></el-option>
                  <el-option class="select-primary" :value="50" :label="50" :key="50"></el-option>
                  <el-option class="select-primary" :value="100" :label="100" :key="100"></el-option>
                </el-select>
              </div>
            </div>

            </card>
          </div>

    <modal :show.sync="modals.welcome" body-classes="p-0" modal-classes="modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <base-button type="secondary" @click="modals.welcome = false" class="close"><i class="tim-icons icon-simple-remove"></i></base-button>
        </div>
      </div>

      <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
        <h3>Importance Notice</h3>
        <iframe id="welcome-modal" src="/members-education-center/notice-information/"/>
        <base-button v-on:click="closeWelcomeModal">Sounds good!</base-button>
        <div>
          <base-checkbox v-on:input="switchWelcomeModal">Don't show this message again</base-checkbox>
        </div>
      </card>
    </modal>

  </div>
</template>
<script>
var { DateTime } = require('luxon');
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css'
import {BaseProgress} from '../../../src/components';
import {BaseSwitch} from '../../../src/components';
import {BasePagination} from '../../../src/components';
import {Select, Option} from 'element-ui';
import { Modal } from 'src/components';
import {Tooltip} from 'element-ui'

const axios = require('axios');
import io from 'socket.io-client';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import Popper from 'vue-popperjs';

export default {
  name: 'Dashboard',
  components: {
    BasePagination,
    axios,
    BaseProgress,
    BaseSwitch,
    Modal,
    [Tooltip.name]: Tooltip,
    [Select.name]: Select,
    [Option.name]: Option,
    'popper': Popper
  },
  data() {
    return {
      wpdata: {announcement: null},
      files: null,
      audio: null,
      chatAudio: null,
      privateAudio: null,
      areAlertsLoading: true,
      message: null,
      socket: null,
      chat: [],
      chatCount: null,
      alerts: [],
      columns: [],
      page: 1,
      perPage: 5,
      pageCount: 20,
      viewImage: null,
      selectedUser: {
        message: 'Loading...'
      },
      selectedForex: [],
      forex: [
        {label:'AUD/CAD', value:'AUDCAD'},
        {label:'AUD/CHF', value:'AUDCHF'},
        {label:'AUD/JPY', value:'AUDJPY'},
        {label:'AUD/NZD', value:'AUDNZD'},
        {label:'AUD/USD', value:'AUDUSD'},
        {label:'CAD/CHF', value:'CADCHF'},
        {label:'CHF/JPY', value:'CHFJPY'},
        {label:'EUR/AUD', value:'EURAUD'},
        {label:'EUR/CAD', value:'EURCAD'},
        {label:'EUR/CHF', value:'EURCHF'},
        {label:'EUR/GBP', value:'EURGBP'},
        {label:'EUR/JPY', value:'EURJPY'},
        {label:'EUR/NZD', value:'EURNZD'},
        {label:'EUR/USD', value:'EURUSD'},
        {label:'GBP/AUD', value:'GBPAUD'},
        {label:'GBP/CAD', value:'GBPCAD'},
        {label:'GBP/CHF', value:'GBPCHF'},
        {label:'GBP/JPY', value:'GBPJPY'},
        {label:'GBP/NZD', value:'GBPNZD'},
        {label:'GBP/USD', value:'GBPUSD'},
        {label:'USD/CAD', value:'USDCAD'},
        {label:'USD/CHF', value:'USDCHF'},
        {label:'USD/JPY', value:'USDJPY'}
      ],
      selectedFutures: [],
      futures: [
        {label:'COCOA', value:'COCOA'},
        {label:'COFFEE', value:'COFFEE_C'},
        {label:'COPPER', value:'COPPER'},
        {label:'CORN', value:'CORN'},
        {label:'Crude OIL', value:'CrudeOIL'},
        {label:'GOLD', value:'GOLD'},
        {label:'NATURAL GAS', value:'NATURAL_GAS'},
        {label:'SILVER', value:'SILVER'},
        {label:'SOYBEAN', value:'SOYBEAN'},
      ],
      selectedIndexes: [],
      indexes:[
        {label:'DOW30 (US_30)', value:'US_30'},
        {label:'NASDAQ100 (US_TECH100)', value:'US_TECH100'},
        {label:'S&P500 (US_500)', value:'US_500'},
        {label:'RUSSELL2000 (US_2000)', value:'US_2000'},
        {label:'DOLLAR_INDX', value:'DOLLAR_INDX'},
        {label:'FTSE100', value:'FTSE100'},
        {label:'NIKKEI225', value:'NIKKEI225'},
      ],
      selectedCrypto: [],
      crypto:[
        {label:'BCHUSDBI', value:'BCHUSDBI'},
        {label:'BTCUSDBI', value:'BTCUSDBI'},
        {label:'ETHUSDBI', value:'ETHUSDBI'},
      ],
      presetValues: [
        {value: 'id', label: 'ID' },
        {value: 'alert_direction', label: 'Direction' },
        {value: 'alert_timestamp', label: 'Time' },
        {value: 'alert_symbol', label: 'Symbol' },
        {value: 'alert_period', label: 'Period' },
        {value: 'alert_pattern', label: 'Pattern' },
        {value: 'alert_currentprice', label: 'Current Price' },
        {value: 'alert_enterbetween', label: 'Reversal Area' },
        {value: 'alert_stopprice', label: 'Invalidation Point' },
        {value: 'alert_target1', label: 'Levels' },
        {value: 'alert_graph', label: 'Chart' },
        {value: 'alert_rvr', label: 'RvR' },
        {value: 'alert_score', label: 'Structure' }
      ],
      filters:{
        id: '',
        min_rvr: '',
        max_rvr: '',
        structure: '',
        structure_op: '=',
        symbol: [],
        period: [],
        pattern: [],
        selectedForex: [],
        selectedFutures: [],
        selectedIndexes: [],
        selectedCrypto: [],
      },
      settings: {
        timezone: 'UTC+00:00',
        visualAlerts: false,
        audioAlerts: false,
        emailAlerts: false,
        selectedChatSound: 'chat.mp3',
        selectedPrivateSound: 'sonar_ping.mp3',
        selectedSound: 'AirHorn.mp3',
        columnPresets: ['id','alert_direction','alert_timestamp','alert_symbol','alert_period','alert_pattern','alert_currentprice','alert_enterbetween','alert_enterbetween','alert_stopprice','alert_target1','alert_graph','alert_rvr','alert_score'],

      },
      modals: {
        filters: false,
        presets: false,
        settings: false,
        alerts: false,
        image: false,
        user: false,
        welcome: localStorage.getItem('welcome') !== 'true',
      },
      ops: {
        '=': function(a, b) { return a == b },
        '>': function(a, b) { return a > b },
        '<': function(a, b) { return a < b },
        '>=': function(a, b) { return a >= b },
        '<=': function(a, b) { return a <= b },
      },
      helpers: {
        isPriavteMode: false,
        showPrivateUser: {},
      },
      usersOnline: [],
      emoji: {
    '\(angry\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/angry.png',
    '\(bang\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/bang.png',
    '\(beer\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/beer.png',
    '\(burger\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/burger.png',
    '\(call\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/call.png',
    '\(cheers\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/cheers.png',
    '\(clover\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/clover.png',
    '\(coffee\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/coffee.png',
    '\(crazy\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/crazy.png',
    '\(crying\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/crying.png',
    '\(crystal\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/crystal.png',
    '\(goodluck\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/goodluck.png',
    '\(grin\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/grin.png',
    '\(heart\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/heart.png',
    '\(horseshoe\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/horseshoe.png',
    '\(icecream\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/icecream.png',
    '\(joy\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/joy.png',
    '\(kiss\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/kiss.png',
    '\(little\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/little.png',
    '\(lmao\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/lmao.png',
    '\(mag\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/mag.png',
    '\(money\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/money.png',
    '\(ok\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/ok.png',
    '\(party\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/party.png',
    '\(peace\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/peace.png',
    '\(perfect\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/perfect.png',
    '\(poo\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/poo.png',
    '\(rainbow\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/rainbow.png',
    '\(shocked\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/shocked.png',
    '\(sick\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/sick.png',
    '\(smile\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/smile.png',
    '\(smirk\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/smirk.png',
    '\(think\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/think.png',
    '\(thumbdown\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/thumbdown.png',
    '\(thumbup\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/thumbup.png',
    '\(tongue\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/tongue.png',
    '\(wink\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/wink.png',
    '\(worried\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/worried.png',
    '\(xheart\)': 'https://www.xabcdtrading.com/dashboard/emoticons/v2/xheart.png'
      },
    }
  },
  watch: {
    // whenever question changes, this function will run
    settings:{
      deep: true,
      async handler (newSettings, oldSettings) {

        const response = await axios.get(process.env.VUE_APP_URL+'/dashboard/settings.php',{ params: {settings: newSettings, id:  window.user.data.ID} });
        console.log('Updated Settings Meta!');

      }
    },
    selectedForex:{
      deep: true,
      async handler(newVal, oldVal){
        this.filters.selectedForex = newVal;
        this.filters.symbol = newVal.concat(this.selectedFutures, this.selectedIndexes, this.selectedCrypto);
      }
    },
    selectedFutures:{
      deep: true,
      async handler(newVal, oldVal){
        this.filters.selectedFutures = newVal;
        this.filters.symbol = newVal.concat(this.selectedForex, this.selectedIndexes, this.selectedCrypto);
      }
    },
    selectedIndexes:{
      deep: true,
      async handler(newVal, oldVal){
        this.filters.selectedIndexes = newVal;
        this.filters.symbol = newVal.concat(this.selectedForex, this.selectedFutures, this.selectedCrypto);
      }
    },
    selectedCrypto:{
      deep: true,
      async handler(newVal, oldVal){
        this.filters.selectedCrypto = newVal;
        this.filters.symbol = newVal.concat(this.selectedForex, this.selectedFutures, this.selectedIndexes);
      }
    },
    filters:{
      deep: true,
      async handler (newFilters, oldFilters) {

        const response = await axios.get(process.env.VUE_APP_URL+'/dashboard/filters.php',{ params: {filters: newFilters, id:  window.user.data.ID} });
        console.log('Updated Filters Data!');
        console.log(newFilters);
        this.loadAlerts();

      }
    }
  },
  computed: {
    getUser(){
       return this.$store.state.user;
    },
    F(){ return ( this.page * this.perPage ) - this.perPage; },
    L(){ return this.F + this.perPage; },
    periods(){
      return [{label:'5M', value:'5M'}, {label:'15M', value:'15M'}, {label:'30M', value:'30M'}, {label:'H1', value:'H1'}, {label:'H4', value:'H4'}, {label:'D1', value:'D1'} ];
    },
    patterns(){
    return [
      {label:'BULLISH RTP-1', value:'Bullish RTP-1'},
      {label:'BEARISH RTP-1', value:'Bearish RTP-1'},
      {label:'BULLISH RTP-2', value:'Bullish RTP-2'},
      {label:'BEARISH RTP-2', value:'Bearish RTP-2'},
      {label:'BULLISH ETP-1', value:'Bullish ETP-1'},
      {label:'BEARISH ETP-1', value:'Bearish ETP-1'},
      {label:'BULLISH ETP-2', value:'Bullish ETP-2'},
      {label:'BEARISH ETP-2', value:'Bearish ETP-2'},
      {label:'BULLISH ETP-3', value:'Bullish ETP-3'},
      {label:'BEARISH ETP-3', value:'Bearish ETP-3'},
      {label:'BULLISH ETP-4', value:'Bullish ETP-4'},
      {label:'BEARISH ETP-4', value:'Bearish ETP-4'},
      {label:'BULLISH ETP-5', value:'Bullish ETP-5'},
      {label:'BEARISH ETP-5', value:'Bearish ETP-5'},
    ];


    },

    filteredAlerts(){
      var scope = this;
      var alerts = this.alerts;
      if(this.filters.id.length) alerts = alerts.filter(function(alert){ if(alert.id == scope.filters.id) return true; });
      if(this.filters.min_rvr.length) alerts = alerts.filter(function(alert){ if(alert.alert_rvr >= scope.filters.min_rvr) return true; });
      if(this.filters.max_rvr.length) alerts = alerts.filter(function(alert){ if(alert.alert_rvr <= scope.filters.max_rvr) return true; });
    //  if(this.filters.symbol.length) alerts = alerts.filter(function(alert){ if(scope.filters.symbol.includes(alert.alert_symbol)) return true; });
      if(this.filters.period.length) alerts = alerts.filter(function(alert){ if(scope.filters.period.includes(alert.alert_period)) return true; });
      if(this.filters.pattern.length) alerts = alerts.filter(function(alert){ if(scope.filters.pattern.includes(alert.alert_pattern)) return true; });
      if(this.filters.structure.length) alerts = alerts.filter(function(alert){ if( scope.ops[scope.filters.structure_op](alert.alert_score, scope.filters.structure) ) return true; });
      this.updateLastAlertId(alerts[0]);
    return alerts;
    }
  },
  methods: {
    async updateChatId(message){
      if(message.private == 'all'){
        const response = await axios.get(process.env.VUE_APP_URL+'/dashboard/lastChatId.php',{ params: {lastChatId: message.id, id:  window.user.data.ID} });
          console.log('Updated Chat Alert ID!');
      }else{
        console.log(message);
        const response = await axios.get(process.env.VUE_APP_URL+'/dashboard/lastPrivateId.php',{ params: {lastPrivateId: message.id, id:  window.user.data.ID} });
        console.log('Updated Private Alert ID!');
      }

    },
    async updateLastAlertId(alert){
      if(!alert) return;
      if(this.getUser.data.emailAlerts.evenIf) return;
      const response = await axios.get(process.env.VUE_APP_URL+'/dashboard/lastAlertId.php',{ params: {lastAlertId: alert.id, id:  window.user.data.ID} });
      console.log('Updated Last Alert ID!');
    },
    async updateMentionId(message){
      const username = this.getMention( message.message );

      if ( username ) {
        this.loadUser(username, (user) => {
          console.log(user)
          const response = axios.get(process.env.VUE_APP_URL+'/dashboard/lastMentionId.php',{ params: { lastMentionId: message.id, id:  user.id } });
          console.log('Updated Mention Alert ID!');
        })
      }
    },

    async uploadFile(event){
      console.log('Uploading!');
      this.files = event.target.files;
      const formData = new FormData();
      for (const i of Object.keys(this.files)) {
        formData.append('files', this.files[i]);
      }
      const response = await axios.post(process.env.VUE_APP_URL+':8443/file-upload', formData);
      console.log('Upload Complete!');
      if(response.data.success){
        this.socket.emit('message', {user: window.user, message:'<a target="_new" href="'+process.env.VUE_APP_URL+'/dashboard/uploads/'+response.data.name+'">'+response.data.name+'</a>'});
      }else{
        swal.fire({
         title: 'Sorry, image must be JPEG or PNG.',
         buttonsStyling: false,
         customClass: {
           confirmButton: 'btn btn-success btn-fill'
         }
       });
      }

    },
    attachFile(){
      console.log('Upload Clicked!');
      const elem = this.$refs.filebtn;
      elem.click();

    },
    highlight(message){
       var admins = ['chris', 'tk'];
       if(admins.includes(message.name)) return true;

      return false;
    },
    highlightadmin(message){
       var admins = ['xabcdteam', 'tk'];
       if(admins.includes(message.name)) return true;

      return false;
    },
    isMuted(message){
      if(window.user.roles.includes("administrator")) return false;
      if(window.user.data.user_nicename == message.name) return false;
      if(message.muted) return true;
      return false;
    },

    // Private Messages
    isPrivate(message){
      if(message.private !== 'all') return true;
      return false;
    },
    hidePrivate(message){
      if( ! this.helpers.isPriavteMode && message.private == 'all') return false;

      // Show all private messaged in the global list
      if( ! this.helpers.isPriavteMode &&
        (
          message.name === window.user.data.user_nicename  ||
          message.private === window.user.data.user_nicename
        )
      ) {
        return false;
      }

      // Hide messages by user name. Hide if this is private message from current user to someone
      if( this.helpers.isPriavteMode &&
          typeof this.helpers.showPrivateUser[message.private] !== "undefined" &&
          message.name === window.user.data.user_nicename && this.helpers.showPrivateUser[message.private] === true
      ) {
        return false;
      }

      // Hide messages by user name. Hide if this is private message from someone user to current user
      if( this.helpers.isPriavteMode &&
          typeof this.helpers.showPrivateUser[message.name] !== "undefined" &&
          message.private === window.user.data.user_nicename && this.helpers.showPrivateUser[message.name] === true
      ) {
        return false;
      }

      return true;
    },
    updatePrivateUsers(data){
      if( Array.isArray(data ) || typeof data.id !== 'undefined' ) {
        return;
      }

      data.map((message) => {
        if( message.private !== 'all' && typeof this.helpers.showPrivateUser[message.private] === 'undefined' ) {
          this.helpers.showPrivateUser[message.private] = false;
        }
      })
    },
    togglePrivateUser(user){
      this.helpers.isPriavteMode = ( this.helpers.showPrivateUser[user] === false || typeof this.helpers.showPrivateUser[user] === 'undefined' ) ? true : false;
      this.helpers.showPrivateUser[user] = ( this.helpers.showPrivateUser[user] === true ) ? false : true;
      this.chat = this.chat.slice();
    },

    // Toggle elements
    showUserModal( userLogin ) {
      this.modals.user = true;
      const response = axios.get(
        process.env.VUE_APP_URL+'/dashboard/getUser.php',
        { params: {
          user_login: userLogin,
        } }
      ).then((response) => {
        this.selectedUser = response.data.data;
      }).catch((err) => {

        if( typeof err.response.data.data !== "undefined" ) {
          this.selectedUser = err.response.data.data;
        } else {
          this.selectedUser = {
            'code': 'error',
            'messasge': 'Something wrong'
          };
        }
      })

    },

    chatScroll(e){
      if(e.srcElement.scrollHeight - e.srcElement.scrollTop <= 300){
        console.log('Loading More Chats!', );
        this.socket.emit('scroll', this.chat.length);
      }
    },
    displayImageModal(img){
      this.viewImage = img;
      this.modals.image = true;
    },
    privateAlert(){
        var sound = process.env.VUE_APP_URL+'/dashboard/sounds/alert-sounds/'+this.settings.selectedPrivateSound;
        this.privateAudio = null;
        this.privateAudio = new Audio(sound);
        this.privateAudio.load();
        this.privateAudio.play();
        this.privateAudio = null;
       console.log('playing private alert sound!');
    },
    chatAlert(message){
        var sound = process.env.VUE_APP_URL+'/dashboard/sounds/alert-sounds/'+this.settings.selectedChatSound;
        if(message.private !== 'all') sound = process.env.VUE_APP_URL+'/dashboard/sounds/alert-sounds/'+this.settings.selectedPrivateSound;
        this.chatAudio = null;
        this.chatAudio = new Audio(sound);
        this.chatAudio.load();
        this.chatAudio.play();
        this.chatAudio = null;
       console.log('playing chat alert!');
    },
    audioAlert (sound) {
      console.log('audioAlert!');
     if(sound) {
       this.audio = new Audio(sound);
       this.audio.play();
     }
   },
    playSound(sound) {
      var audio = new Audio(process.env.VUE_APP_URL + '/dashboard/sounds/alert-sounds/' + sound)
      audio.play();
    },
    visualAlert() {
          swal.fire({
           title: 'New Alert '+this.filteredAlerts[0].alert_symbol+' '+this.filteredAlerts[0].alert_period,
           buttonsStyling: false,
           customClass: {
             confirmButton: 'btn btn-success btn-fill'
           }
         });
      },
    showColumn(colName){
      if(this.settings.columnPresets.includes(colName)) return true;
      return false;
    },
    rowClass(d){

      if(d == 2) return 'text-danger';
      return 'text-success';
    },
    directionIcon(d){
      if(d == 2) return '<i class="tim-icons icon-minimal-down"></i>';
      return '<i class="tim-icons icon-minimal-up"></i>';
    },
    sendMessage(){
      if( this.helpers.isPriavteMode ) {
        this.message = '/msg ' + this.selectedUser.login + ' ' + this.message
      }

      this.socket.emit('message', {user: window.user, message: this.checkMessageForLinks(this.message)});
      this.message = null;
    },
    addEmojiToMessage(emoji){

      const input = document.getElementById('input-message');
      let pos = 0;

      if( input ) {
        pos = input.selectionStart
      }

      if( this.message ) {
        console.log(this.message);
        this.message = this.message.substr(0, pos) + emoji + this.message.substr(pos);
      } else {
        this.message = emoji;
      }

    },
    closeWelcomeModal() {
      this.modals.welcome = false;
    },
    switchWelcomeModal(event) {
      if (event === true) {
        localStorage.setItem('welcome', 'true')
      } else {
        localStorage.removeItem('welcome')
      }
    },
    checkMessageForLinks(text, new_window) {
      var url_pattern = /(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?/ig;
      var target = (new_window === true || new_window == null) ? '_blank' : '';

      return text.replace(url_pattern, function (url) {
        var protocol_pattern = /^(?:(?:https?|ftp):\/\/)/i;
        var currency_pattern = /(^|\s)\d{1,5}.\d{1,4}(\s|$)/

        if( currency_pattern.test(url) ) {
          return url;
        }

        var protocol_pattern = /^(?:(?:https?|ftp):\/\/)/i;
        var href = protocol_pattern.test(url) ? url : 'http://' + url;
        return '<a href="' + href + '" target="' + target + '">' + url + '</a>';
      });
    },
    async loadAlerts(){
      console.log('Refreshing Alerts...');

      this.areAlertsLoading = true;
      try {
        const response = await axios.post(process.env.VUE_APP_URL+':8443/alerts',this.filters);
        var filteredOld = this.filteredAlerts;
        this.alerts = response.data
        this.setAlertPagesCount();

        if(filteredOld[0]){
          if(filteredOld[0].id != this.filteredAlerts[0].id){
            if(this.settings.visualAlerts)this.visualAlert();
            if(this.settings.audioAlerts)this.audioAlert(process.env.VUE_APP_URL+'/dashboard/sounds/alert-sounds/'+this.settings.selectedSound);
          }
        }

      } catch (error) {
        console.error(error);
      }
      this.areAlertsLoading = false;
    },
    setAlertPagesCount(){
      if( typeof this.alerts === 'undefined' || this.filteredAlerts.length === 0 ) {
        this.pageCount = 1;
        return;
      }

      this.pageCount = this.filteredAlerts.length / this.perPage;
    },
    loadSettings(){

      if(  window.user.data.settings ) this.settings = window.user.data.settings;
      if(  window.user.data.filters){
        this.filters = window.user.data.filters;
        this.selectedForex = this.filters.selectedForex;
        this.selectedFutures = this.filters.selectedFutures;
        this.selectedIndexes = this.filters.selectedIndexes;
        this.selectedCrypto = this.filters.selectedCrypto;

      }

    },
    loadUser(userLogin, callback){
      const response = axios.get(
        process.env.VUE_APP_URL + '/dashboard/getUser.php',
        { params: {
            user_login: userLogin,
          } }
      ).then((response) => {
        callback( response.data.data );
      })
    },

    // Helpers
    unixToDate(timestamp){
      return  DateTime.fromSeconds(parseInt(timestamp)).setZone(this.settings.timezone).toLocaleString(DateTime.DATETIME_SHORT);
    },
    unixMilisecondsToDate(time){
      const date = DateTime.fromMillis(parseInt(time)).setZone(this.settings.timezone).toLocaleString(DateTime.DATETIME_SHORT);
      return date;
    },
    getMention(message) {
      const rx     = /@\w+/g;
      const result = rx.exec(message);

      if( result && typeof result[0] !== 'undefined' ) {
        return result[0].replace('@', '');
      }

      return false;
    }
  },
  async mounted() {
    console.log('INIT!');
    console.log('STATE', this.getUser);
    console.log('ENV', process.env.NODE_ENV );
    this.wpdata = window.data;

    var scroller            = new PerfectScrollbar('#chatScroll');
    var usersOnlineScroller = new PerfectScrollbar('#usersOnline', {
      'suppressScrollY': true,
    });
    var EmojiScroller = new PerfectScrollbar('#EmojiList', {
      'suppressScrollY': true,
    });

    this.loadSettings();
    this.loadAlerts();
    setInterval(this.loadAlerts, 60000);
    var scope = this;
    this.socket = io(process.env.VUE_APP_URL+':8443');
    this.socket.on('connect', function(){
      console.log('connected!');
    });
    this.socket.on('count', function(data){
     scope.chatCount = data;
    });

    this.socket.on('usersOnline', function(data){
      scope.usersOnline = data;
    });

    this.socket.on('mute', function(data){
     scope.mute = data;
    });

    this.socket.on('refresh', function(data){
     window.location.reload();
    });

    this.socket.on('newmessage', function(data){
      console.log('newmessage',data);
      scope.chat.unshift(data);
      if(!scope.hidePrivate(data))scope.chatAlert(data);
      scope.updateChatId(data);
      scope.updateMentionId(data);
      console.log(data);
      scope.updatePrivateUsers(data);
    });

    this.socket.on('load', function(data){
      console.log('Loaded Alert Data!');
      scope.chat = data;
      scope.updatePrivateUsers(data);
    });

    this.socket.emit('loginUser',{
      user: {
        login: window.user.data.user_login,
        avatar: window.user.data.avatar
      }
    });

  },
  beforeDestroy() {
  }
};
</script>
<style>


.announcement{color: white; border: 1px solid rgb(173, 113, 224); border-radius: 3px; text-align: center; padding: 1rem; margin-bottom: 2rem;}


li.hidePrivate{display: none;}
li.muted{display: none;}
li.displayMuted{display: block;}
li.highlight, li.highlight *{color: #ffd600 !important}
li.highlightadmin, li.highlightadmin *{color: #ff8d72 !important}
li.private, li.private *{color: #00f2c3 !important}
.table-wrapper{overflow-x: auto;}
.icon-minimal-up{color: #5cdc7f}
.icon-minimal-down{color: #ff5192}

.text-color{color: rgba(255, 255, 255, 0.7) !important;}

 .base.nudge{margin-top: 10px; margin-left: 1rem;}
.snudge{margin-bottom:1rem;}

.modal.show .modal-dialog {
    /* -webkit-transform: translate(0, 30%); */
    /* transform: translate(0, 30%); */
    -webkit-transform: none !important;
    transform: none !important;
}


#welcome-modal {
  width: 100%;
  height: 60vh;
}

/*
	Max width before this PARTICULAR table gets nasty. This query will take effect for any screen smaller than 760px and also iPads specifically.
	*/
  th{
    color: white;
    padding: 0.5rem 0 !important;
  }

  .optionfix {
      color:black
  }

  .alerts-table{font-size:14px; color: white !important;}
  .alerts-table > tbody > tr > td{padding: 0rem; margin:0; text-transform: uppercase; color: inherit !important;}
  .alerts-table > tbody > tr{padding:0; margin:0;}
	@media
	  only screen
    and (max-width: 760px), (min-device-width: 768px)
    and (max-device-width: 1024px)  {

		/* Force table to not be like tables anymore */
		table, thead, tbody, th, td, tr {
			display: block;

		}

		/* Hide table headers (but not display: none;, for accessibility) */
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}

    tr {
      margin: 0 0 3rem 0;
      border-bottom: 0.5rem solid #ad71e0 !important;
padding-bottom: 2rem !important;
      margin-bottom: 2rem !important;
    }

    tr:nth-child(odd) {

    }

		td {
			/* Behave  like a "row" */

      min-height: 3.3rem !important;
      position: relative;
			padding: 1rem 1rem 1rem 10rem !important;
      text-align: left !important;
		}

		td:before {
			/* Now like a table header */
			position: absolute;
      height: 1rem;
      padding: 1rem !important;
      font-weight: bold;
			/* Top/left values mimic padding */
			top: 0;
			left: 6px;
			width: 5rem;
			padding-right: 10px;
      text-align: left !important;
			white-space: nowrap;
		}

		/*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/
    td:nth-of-type(0):before { content: "ID"; }
		td:nth-of-type(1):before { content: "ID"; }
		td:nth-of-type(2):before { content: "Direction"; }
		td:nth-of-type(3):before { content: "Time"; }
		td:nth-of-type(4):before { content: "Symbol"; }
		td:nth-of-type(5):before { content: "Period"; }
		td:nth-of-type(6):before { content: "Pattern"; }
		td:nth-of-type(7):before { content: "Current Price"; }
		td:nth-of-type(8):before { content: "Reversal Area"; }
		td:nth-of-type(9):before { content: "Invalidation Point"; }
		td:nth-of-type(10):before { content: "Levels"; }
		td:nth-of-type(11):before { content: "Chart"; }
    td:nth-of-type(12):before { content: "RvR"; }
    td:nth-of-type(13):before { content: "Structure"; }


	}

.modal-chart {
  max-width: 1440px;
  padding: 0 1.75rem;
}

</style>
